import { FaRegEdit, FaCheck, FaTimes } from "react-icons/fa";
import {useState, useEffect} from 'react';
import { useSelector } from "react-redux";
import { updateSchemeExpenseConfig, updateSchemePaymentMethod } from "../../../../helper/Api";
import { toast } from "react-toastify";

const SchemeDetailsOverlay = ({
    handleOpen,
    overlay,
    setOverlay,
    overlayDropDown,
    setOverlayDropDown,
    schemeDetails,
    handleSchemFormData,
    approvalHandler,
    setLoading,
    setFilterApplied
}) => {
    const { authData } = useSelector((state) => state.authData);
    const [paymentModeChangeActive, setPaymentModeChangeActive] = useState(false);
    const [paymentMode, setPaymentMode] = useState(schemeDetails.payment_type);
    const [expensePermissionChangeActive, setExpensePermissionChangeActive] = useState(false);
    const getPaymentTypes = () => ({
        reimbursement: Number(schemeDetails?.is_reimbursement_active) === 1,
        disbursement: Number(schemeDetails?.is_disbursement_active) === 1,
        salary: Number(schemeDetails?.is_salary_active) === 1
    });
    const [formData, setFormData] = useState({
        paymentTypes: getPaymentTypes()
    });

    const handleChangePaymentMode = async () => {
        try {
            setLoading(true)
            const response = await updateSchemePaymentMethod({
                scheme_id: schemeDetails.id,
                payment_method: paymentMode
            });
            if(response.data.status) {
                toast.success("Payment mode updated successfully", {
                    position: toast.POSITION.TOP_CENTER,
                });
            } else {
                toast.error("Something went wrong while updating payment mode", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
            setPaymentModeChangeActive(false);
            setLoading(false);
            setOverlay(true);
            setFilterApplied((prev) => ({
                ...prev,
                refresh: !prev.refresh
            }));
        }catch(err) {
            setLoading(false);
            toast.error("Something went wrong while updating payment mode", {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    }

    useEffect(() => {
        setFormData({
            paymentTypes: getPaymentTypes()
        });
    }, [schemeDetails?.id, schemeDetails?.is_reimbursement_active, schemeDetails?.is_disbursement_active, schemeDetails?.is_salary_active])

   const handleChangeExpensePermission = async () => {
        try{
            setLoading(true);
            const response = await updateSchemeExpenseConfig({
                scheme_id: schemeDetails.id,
                is_reimbursement_active: formData.paymentTypes.reimbursement ? 1 : 0,
                is_disbursement_active: formData.paymentTypes.disbursement ? 1 : 0,
                is_salary_active: formData.paymentTypes.salary ? 1 : 0
            });
            if(response.data.status) {
                toast.success("Expense permissions updated successfully", {
                    position: toast.POSITION.TOP_CENTER,
                });
            } else {
                toast.error("Something went wrong while updating expense permissions", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
            
            setLoading(false);
            setOverlay(true);
            setFilterApplied((prev) => ({
                ...prev,
                refresh: !prev.refresh
            }));
        }catch(err) {
            setLoading(false);
            toast.error("Something went wrong while updating expense permissions", {
                position: toast.POSITION.TOP_CENTER,
            });
        }
        setExpensePermissionChangeActive(false);
    }

    return (
        <>
        <div className={`overlay ${overlay ? "d-none" : null}  `}></div>
        <div
            className={`overlayContent overflow-auto ${
            overlay ? "left-100" : null
            } `}
            onClick={(e) => e.stopPropagation()}
            >
            <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center ps-4">
            <div className="fw-600 fs-16px d-flex align-items-center gap-2 ">
                <i
                className="icon-close_circle_fill fs-5  cursor-pointer"
                onClick={() => setOverlay(true)}
                ></i>
                Scheme
            </div>

            <div className="d-flex gap-2 align-items-center h-100 py-3 position-relative pe-4">
                <span>As on date (date)</span>
                <i
                className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
                onClick={() => setOverlayDropDown((prev) => !prev)}
                ></i>

                <div
                className={`position-absolute bg-prime-100 w-100 p-3 ${
                    !overlayDropDown ? "d-none" : "d-inline-block"
                }`}
                style={{ top: "100%", zIndex: "10" }}
                >
                <div className="d-flex flex-column gap-4">
                    <span className="d-flex align-items-center gap-2 cursor-pointer">
                    <i className="icon-picture_as_pdf"></i> Export PDF
                    </span>
                </div>
                </div>
            </div>
            </div>

            <div className="px-4 py-3 d-flex flex-column gap-2">
                <div className="bg-white border-prime-20">
                    <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden">
                    {/* ======================card header================== */}
                    <span
                        className="fs-14px white-space-nowrap overflow-x-hidden"
                        style={{ width: "95%", fontStyle: "italic" }}
                    >
                        {/* =======================card header====================== */}
                        <span
                        className="fs-14px white-space-nowrap overflow-x-hidden "
                        style={{ width: "95%" }}
                        >
                        <span
                            className="fw-600 fs-16px"
                            style={{ fontStyle: "normal" }}
                        >
                            General
                        </span>
                        </span>
                    </span>
                    </div>

                    {/* ================================card body========================= */}

                    <div className="row p-2 m-0">
                    <div className="px-1 col-4">
                        <span
                        className="d-flex flex-column p-0 px-1"
                        >
                        <label htmlFor="text" className="fs-12px text-prime-100">
                            Financial Year* :
                        </label>
                        <p className="fs-14px border-bottom-only">{schemeDetails?.financial_year}</p>
                        </span>
                    </div>

                    <div className="col-4 px-1">
                        <span className="d-flex flex-column p-0 px-1">
                        <label htmlFor="text" className="fs-12px text-prime-100">
                            Department
                        </label>
                        <p className="fs-14px border-bottom-only">{schemeDetails.department}</p>
                        </span>
                    </div>

                    <div className="col-4 px-1">
                        <span className="d-flex flex-column p-0 px-1">
                        <label htmlFor="text" className="fs-12px text-prime-100">
                            Scheme Type
                        </label>
                        <p className="fs-14px border-bottom-only">{schemeDetails.type}</p>
                        </span>
                    </div>
                    </div>

                    <div className="row m-0 p-2">
                    <div className="col-2 px-1 ">
                        <span className="d-flex flex-column p-0 px-1">
                        <label htmlFor="text" className="fs-12px text-prime-100">
                            Grant Code
                        </label>
                        <p className="fs-14px border-bottom-only">{schemeDetails.grant_code}</p>
                        </span>
                    </div>
                    <div className="col-2 px-1">
                        <span className="d-flex flex-column p-0 px-1">
                        <label htmlFor="text" className="fs-12px text-prime-100">
                            Scheme Code
                        </label>
                        <p className="fs-14px border-bottom-only">{schemeDetails.code}</p>
                        </span>
                    </div>
                    <div className="col-8 px-1">
                        <span className="d-flex flex-column p-0 px-1">
                        <label htmlFor="text" className="fs-12px text-prime-100">
                            Scheme Name
                        </label>
                        <p className="fs-14px border-bottom-only">{schemeDetails.name}</p>
                        </span>
                    </div>
                    </div>

                    <div className="row m-0 p-2">
                    <div className="px-1 col-10">
                        <span className="d-flex flex-column p-0 px-1 ">
                        <label htmlFor="text" className="fs-12px text-prime-100">
                            Account No.
                        </label>
                        <p className="fs-14px border-bottom-only">{schemeDetails?.bank_details?.account_no}</p>
                        </span>
                    </div>

                    <div className="col-2 p-0 m-0 px-1 d-flex align-items-center gap-2">
                        <button
                        onClick={() => handleOpen(schemeDetails.bank_details)}
                        className="m-0 py-1 px-1 text-prime-100 fs-16px bg-white rounded-2 d-flex align-items-center w-100 gap-1"
                        style={{ border: "1px solid #2490EA" }}
                        >
                        {" "}
                        <i className="icon-account_balance"></i> Know more
                        </button>
                        <i className="icon-picture_as_pdf fs-4 p-0 m-0"></i>
                    </div>
                    </div>

                    <div className="row m-0 p-2">
                    {schemeDetails?.sub_head_list?.map(subhead => (
                        <>
                            <div className="px-1 col-2">
                                <span
                                className="d-flex flex-column p-0 px-1"
                                >
                                <label htmlFor="text" className="fs-12px text-prime-100">
                                    Sub Head Code*
                                </label>
                                <p className="fs-14px border-bottom-only">{subhead.code}</p>
                                </span>
                            </div>
                            <div className="px-1 col-8">
                                <span className="d-flex flex-column p-0 px-1" >
                                <label htmlFor="text" className="fs-12px text-prime-100">
                                    Sub Head *
                                </label>
                                <p className="fs-14px border-bottom-only">{subhead.name}</p>
                                </span>
                            </div>
                            <div className="px-1 col-2">
                                <span className="d-flex flex-column p-0 px-1" >
                                    <label htmlFor="text" className="fs-12px text-prime-100">creation Date</label>
                                    <p className="fs-14px border-bottom-only">{subhead.added_on}</p>
                                </span>
                            </div>
                        </>
                    ))}
                    
                    </div>

                    {/* ========================================budgeting================================== */}

                    <div className="bg-prime-20 px-2 fs-16px fw-600 py-1">Budgeting</div>
                    <div className="px-2 d-flex gap-1 py-2">
                    <span className="pe-3 fs-16px">Activity and Sub-activity</span>
                    <div className="d-flex align-items-center gap-1 me-2">
                        <p className={`fs-14px m-0 ${Number(schemeDetails.is_activity_active) === 0 ? 'text-danger' : 'text-success'}`}>{Number(schemeDetails.is_activity_active) === 0 ? 'Disable' : 'Enable'}</p>
                    </div>
                    </div>
                    {Number(schemeDetails.is_activity_active) === 1 ? (
                    <div className="row m-0 px-2">
                        <div className="col-2 m-0 p-0">
                        <span className="pe-3 fs-16px">Control level</span>
                        </div>
                        <div className="col-10">
                        <div className="d-flex align-items-center gap-1 me-2">
                            {Number(schemeDetails.monitoring_level) === 2 && <label htmlFor="report" className="fs-14px"><strong>Report Expenses Solely by Activity and Sub-activity (Monitor only)</strong></label>}
                        </div>
                        <div className="d-flex align-items-center gap-1 me-2">
                            {Number(schemeDetails.monitoring_level) === 3 && <label htmlFor="allocation" className="fs-14px"><strong>Allocate Budget to T2/T3/T4 by Activity and Sub-activity (Control Child Budget)</strong></label>}
                        </div>
                        <div className="d-flex align-items-center gap-1 me-2">
                            {Number(schemeDetails.monitoring_level) === 1 && <label htmlFor="budget" className="fs-14px"><strong>Add Budget at T1 and Allocate to T2/T3/T4 by Activity and
                            Sub-activity (Control Budgeting at All Levels)</strong></label>}
                            
                        </div>
                        </div>
                    </div>
                    ) : null}

                    {/* ========================================DBT I NACH================================== */}

                    <div className="bg-prime-20 px-2 fs-16px fw-600 py-1">
                    DBT | NACH
                    </div>
                    <div className="px-2 d-flex gap-1 py-2">
                    <span className="pe-3 fs-16px">Payment Mandate</span>

                    <div className="d-flex align-items-center gap-1 me-2">
                        {Number(schemeDetails.change_reimbursement_payment_flow) === 0 && <label htmlFor="ena" className="fs-14px"><strong>Enable for All Department</strong></label>}
                    </div>

                    <div className="d-flex align-items-center gap-1">
                        {Number(schemeDetails.change_reimbursement_payment_flow) === 1 && <label htmlFor="pay" className="fs-14px"><strong>Custom Payment Mandate</strong></label>}
                        
                    </div>
                    </div>
                    {Number(schemeDetails.change_reimbursement_payment_flow) === 1 && (
                    <div className="px-2 d-flex gap-1 py-2 rpw">
                        <span className="pe-3 fs-16px col-2">
                        Custom Payment Authorization
                        </span>
                        <span className="d-flex align-items-start gap-1 me-2">
                            {
                                schemeDetails?.reimbursement_payment_levels?.map((r, i) => (
                                    <label>{i > 0 && ', '}{r.toUpperCase()}</label>
                                ))
                            }
                        </span>
                    </div>
                    )}

                    <div className="bg-prime-20 px-2 fs-16px fw-600 py-1">Payment Mode  &nbsp; 
                        {
                            (!paymentModeChangeActive  && authData.user.user_type === 'l3' && Number(authData.user.department_id) === 1) && <FaRegEdit onClick={() => setPaymentModeChangeActive(!paymentModeChangeActive)}/>
                        }
                        
                    </div>
                                       
                    <div className="px-2 d-flex gap-1 py-2">
                        {(schemeDetails.payment_type && !paymentModeChangeActive) && <span className="pe-3 fs-16px">{paymentMode?.toUpperCase() || schemeDetails?.payment_type?.toUpperCase()}</span>}
                        {
                            paymentModeChangeActive && <div className="form-group">
                            <div className="d-flex gap-3">
                                <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="mode"
                                    id="modeOnline"
                                    value="online"
                                    checked={paymentMode === 'online'}
                                    onChange={() => setPaymentMode('online')}
                                />
                                <label className="form-check-label" htmlFor="modeOnline">
                                    Online
                                </label>
                                </div>
                                <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="mode"
                                    id="modeOffline"
                                    value="offline"
                                    checked={paymentMode === 'offline'}
                                    onChange={() => setPaymentMode('offline')}
                                />
                                <label className="form-check-label" htmlFor="modeOffline">
                                    Offline
                                </label>
                                </div>
                                <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="mode"
                                    id="modeBoth"
                                    value="both"
                                    checked={paymentMode === 'both'}
                                    onChange={() => setPaymentMode('both')}
                                />
                                <label className="form-check-label" htmlFor="modeBoth">
                                    Both
                                </label>
                                </div>
                            </div>
                        </div>
                        }
                        
                    </div>
                    {
                        paymentModeChangeActive && <div className="px-2 d-flex gap-1 py-2">
                            <button className="submit_button" onClick={() => handleChangePaymentMode()}>Change Payment Mode</button>
                        </div>
                    }

                    <div className="bg-prime-20 px-2 fs-16px fw-600 py-1">Expense Permissions  &nbsp; 
                        {
                            (!expensePermissionChangeActive && authData.user.user_type === 'l3' && Number(authData.user.department_id) === 1) && <FaRegEdit onClick={() => setExpensePermissionChangeActive(!expensePermissionChangeActive)}/>
                        }
                        
                    </div>
                    {
                        !expensePermissionChangeActive && <div className="px-2 d-flex gap-1 py-2">
                        <p style={{marginRight: '10px'}}>
                            {Number(formData.paymentTypes.disbursement) === 1 ? <FaCheck className="text-success"/> : <FaTimes className="text-danger"/>} 
                            &nbsp; Vendor Payment
                        </p>
                        <p style={{marginRight: '10px'}}>{Number(formData.paymentTypes.reimbursement) === 1 ? <FaCheck className="text-success"/> : <FaTimes className="text-danger"/>} &nbsp; Reimbursement Payment</p>
                        <p>{Number(formData.paymentTypes.salary) === 1 ? <FaCheck className="text-success"/> : <FaTimes className="text-danger"/>} &nbsp; Salary Payment</p>
                    </div>
                    }
                    {
                        expensePermissionChangeActive && <div className="px-2 d-flex gap-1 py-2">
                        <div className="form-group">
                            <div className="d-flex gap-3">
                                <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="reimbursement"
                                    checked={formData.paymentTypes?.reimbursement || false}
                                    onChange={(e) => setFormData((prev) => ({
                                        ...prev,
                                        paymentTypes: {
                                            ...prev.paymentTypes,
                                            reimbursement: e.target.checked
                                        }
                                    }))}
                                />
                                <label className="form-check-label" htmlFor="reimbursement">
                                    Reimbursement
                                </label>
                                </div>
                                <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="disbursement"
                                    checked={formData.paymentTypes?.disbursement || false}
                                    onChange={(e) => setFormData((prev) => ({
                                        ...prev,
                                        paymentTypes: {
                                            ...prev.paymentTypes,
                                            disbursement: e.target.checked
                                        }
                                    }))}
                                />
                                <label className="form-check-label" htmlFor="disbursement">
                                    Disbursement
                                </label>
                                </div>
                                <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="salary"
                                    checked={formData.paymentTypes?.salary || false}
                                    onChange={(e) => setFormData((prev) => ({
                                        ...prev,
                                        paymentTypes: {
                                            ...prev.paymentTypes,
                                            salary: e.target.checked
                                        }
                                    }))}
                                />
                                <label className="form-check-label" htmlFor="salary">
                                    Salary
                                </label>
                                </div>
                            </div>
                            </div>
                    </div>
                    }
                    
                    {
                        expensePermissionChangeActive && <div className="px-2 d-flex gap-1 py-2">
                            <button className="submit_button" onClick={() => handleChangeExpensePermission()}>Change Expense Permission</button>
                        </div>
                    }
                    
                    
                </div>
            </div>
            {
                ((Number(schemeDetails?.l2_status) === 0 && authData.user.user_type === 'l2') || (Number(schemeDetails?.l3_status) === 0 && authData.user.user_type === 'l3')) && (
                    <div className="approval-section">
                        {
                            authData.user.user_type === 'l2' && <>
                            <label>L2 remarks</label>
                            <textarea className="form-control" name="l2remarks" rows="3" onChange={handleSchemFormData}></textarea>
                            </>
                        }

                        {
                            authData.user.user_type === 'l3' && <>
                            <label>L3 remarks</label>
                            <textarea className="form-control" name="l3remarks" rows="3" onChange={handleSchemFormData}></textarea>
                            </>
                        }

                        <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                            <button type="button" onClick={(e) => approvalHandler(e, schemeDetails?.id, 2)} className="btn btn-outline-danger px-4">Reject</button>
                            <button type="button" onClick={(e) => approvalHandler(e, schemeDetails?.id, 1)} className="btn btn-success px-4">Approve</button>
                        </div>
                    </div>
                )
            }
            
        </div>
        </>
    )
}

export default SchemeDetailsOverlay;